const initialState = {
	dataChat: [],
	isLoading: false,
	isBtnLoading: false,
	isError: false,
	errorMessage: "",
	isConversationLoading: false,
	dataConversation: [],
	isConversationError: false,
	errorConversationMessage: "",
	chatRoomOpened: false,
	selectedDmId: null,
	selectedUserId: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "CHAT_FETCH_IS_LOADING":
			return {
				...state,
				isLoading: action.status
			};

		case "CHAT_FETCH_SUCCESS":
			return {
				...state,
				dataChat: action.payload
			};

		case "CHAT_FETCH_IS_ERROR":
			return {
				...state,
				isError: action.status,
				errorMessage: action.message || ""
			};

		case "CHAT_CONV_IS_LOADING":
			return {
				...state,
				isConversationLoading: action.status
			};

		case "CHAT_FETCH_CONV_SUCCESS":
			return {
				...state,
				dataConversation: action.payload
			};

		case "CHAT_FETCH_CONV_IS_ERROR":
			return {
				...state,
				isConversationError: action.status,
				errorConversationMessage: action.message || ""
			};

		case "CHAT_SUBMIT_MSG_IS_LOADING":
			return {
				...state,
				isBtnLoading: action.status
			};

		case "CHAT_ROOM_OPEN":
			return {
				...state,
				chatRoomOpened: action.status
			};

		case "CHAT_UPDATE_SELECTED_DM_ID":
			return {
				...state,
				selectedDmId: action.dmId
			};

		case "CHAT_UPDATE_SELECTED_USER_ID":
			return {
				...state,
				selectedUserId: action.userId
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/chatReducer.js